<template>
  <div class="apply-form">
    <div class="wrapper">
      <el-image style="width: 100%; height: 350px; border-radius: 50px; background: linear-gradient(to right, #FFF9F0, #F9FAFE)" :src="require('@/assets/home/bottom-line.png')" fit="cover"></el-image>
      <div id="scene_apply" style="position: absolute; width: 100vw; z-index: 1">
        <div id="e1" data-depth="0.4" style="position: absolute; margin-top: -320px;"><img style="width: 150px"
                                                                                                    src="@/assets/home/b-l-1.png"/>
        </div>
        <div id="e2" data-depth="0.6" style="position: absolute; margin-top: -150px;"><img style="width: 70px"
                                                                                                    src="@/assets/home/b-l-2.png"/></div>
        <div id="e3" data-depth="0.4" style="position: absolute; margin-top: -300px;"><img style="width: 70px" src="@/assets/home/b-r-1.png"/>
        </div>
        <div id="e4" data-depth="0.6" style="position: absolute; margin-top: -190px;"><img style="width: 150px"
                                                                                                    src="@/assets/home/b-r-2.png"/></div>
      </div>
      <div class="content" style="z-index: 2">
        <div class="title" style="font-size: 32px; font-weight: 500; color: rgb(64, 64, 64)">免费加入欢软开始接单之旅</div>
        <div class="process">
          <span>填写表单并提交</span>
          <span><i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i></span>
          <span>客服对接基本信息</span>
          <span><i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i></span>
          <span>客服上传信息并确认</span>
          <span><i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i></span>
          <span>入驻成功</span>
        </div>
        <div class="input-wrapper">
          <el-input v-model="mobile" placeholder="请输入手机号码"></el-input>
          <el-button type="warning" class="btn">立即体验</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'name',
  data() {
    return ({
      mobile: ''
    })
  },
  mounted() {
    var sceneApply = document.getElementById('scene_apply');
    var parallaxInstance2 = new Parallax(sceneApply, {
      relativeInput: false
    });
    const e1 = document.querySelector('#e1');
    const e2 = document.querySelector('#e2');
    const e3 = document.querySelector('#e3');
    const e4 = document.querySelector('#e4');
    const parent = e1.parentElement;

    function updateMargin() {
      const parentWidth = parent.offsetWidth;
      if (parentWidth < 1700) {
        e1.style.marginLeft = '15%';
        e2.style.marginLeft = '13%';
        e3.style.marginLeft = '55%';
        e4.style.marginLeft = '57%';
      } else {
        e1.style.marginLeft = '250px';
        e2.style.marginLeft = '200px';
        e3.style.marginLeft = '1000px';
        e4.style.marginLeft = '1050px';
      }
    }

// 初始调用
    updateMargin();

// 监听窗口大小变化
    window.addEventListener('resize', updateMargin);
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.apply-form {
  .wrapper {
    width: 80vw;
    max-width: 1400px;
    margin: 100px auto;
    position: relative;
  }
  .content {
    width: 50%;
    position: absolute;
    top: 70px;
    left: 50%;
    // right: 0;
    margin-left: -25%;
    text-align: center;

    .title {
      font-size: 28px;
      font-weight: bold;
      margin: 20px 0;
      text-align: center;
    }

    .process {
      color: #454851;
      font-size: 14px;
      margin-bottom: 20px;
      margin-top: 0;
    }

    .iconfont {
      color: #BEBFC0;
      margin: 0 10px;
    }

    .input-wrapper {
      position: relative;
      max-width: 450px;
      margin: auto;

      .el-input {
        /deep/ .el-input__inner {
          border-radius: 20px;
          padding-left: 25px;
        }

      }

      /deep/ .el-input.is-active .el-input__inner,
      /deep/ .el-input__inner:focus {
        border-color: #C0C4CC;
      }

      .el-button--warning {
        background-color: #FF842E;
      }
    }

    .btn {
      position: absolute;
      bottom: 0;
      right: 0;
      border-radius: 20px;
      padding: 12px 32px;
    }

  }
}
/* 针对手机的样式 */
@media (max-width: 767px) {
  .apply-form {
    .wrapper {
      width: calc(100vw - 20px);
      margin: 100px auto;
	  #scene_apply{
		div:first-child{
			margin-left: 20px !important;
			img{
				width: 80px !important;
			}
		}
		div:nth-child(2){
			margin-left: 35px !important;
			img{
				width: 50px !important;
			}
		}
		div:nth-child(3){
			left: unset !important;
			top: -10px !important;
			right: 0 !important;
			margin-right: 50px !important;
			img{
				width: 60px !important;
			}
		}
		div:last-child{
			top: 35px !important;
			right: 0 !important;
			left: unset !important;
			margin-left: 0 !important;
			margin-right: 65px !important;
			img{
				width: 80px !important;
			}
		}  
	  }
    }
    .content {
      width: 90%;
      position: absolute;
      top: 70px;
      left: 0;
      margin-left: 5%;
      text-align: center;
  
      .title {
        font-size: 28px !important;
      }
  
      .process {
        color: #454851;
        font-size: 14px;
        margin-bottom: 20px;
        margin-top: 0;
      }
  
      .iconfont {
        color: #BEBFC0;
        margin: 0 10px;
      }
  
      .input-wrapper {
        position: relative;
        max-width: 450px;
        margin: auto;
  
        .el-input {
          /deep/ .el-input__inner {
            border-radius: 20px;
            padding-left: 25px;
          }
  
        }

      }
  
      .btn {
        position: absolute;
        bottom: 0;
        right: 0;
        border-radius: 20px;
        padding: 12px 32px;
      }
  
    }
  }
}
</style>
